// frontend/src/pages/PaychequeList/styles.ts
// All style tokens, static style objects, and style factories.
// Keeps JSX readable; easy to swap for a theme or styled-components later.

import type { CSSProperties } from "react";

export const FONT = "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif";

export const C = {
  ink: "#12262B",
  inkDark: "#0E1A1A",
  brand: "#15A08C",
  brandDark: "#0F6E56",
  brandBg: "#E1F5EE",
  amber: "#A67312",
  amberBg: "#FEF6E7",
  grey: "#6B7280",
  greyBg: "#F3F4F6",
  err: "#DC2626",
  errBg: "#FEE2E2",
  page: "#F4F6F8",
  card: "#FFFFFF",
  line: "#E7EAF0",
  lineSoft: "#F1F3F7",
  chequePaper: "#FFFEF7",
  chequeBorder: "#C7CBD1",
} as const;

export const TABULAR: CSSProperties = { fontVariantNumeric: "tabular-nums" };

export const outlineBtn: CSSProperties = {
  padding: "6px 12px",
  background: "transparent",
  border: "1.5px solid " + C.ink,
  borderRadius: 8,
  color: C.ink,
  fontSize: 12,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
};

export const outlineBtnLarger: CSSProperties = Object.assign({}, outlineBtn, {
  padding: "10px 14px",
  borderRadius: 10,
  fontSize: 13,
});

export const footerBtn: CSSProperties = {
  padding: "12px 18px",
  background: C.card,
  border: "1.5px solid " + C.ink,
  borderRadius: 10,
  color: C.ink,
  fontSize: 14,
  fontWeight: 700,
  cursor: "pointer",
  fontFamily: FONT,
};

export const menuItem: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "9px 14px",
  fontSize: 13,
  color: C.ink,
  cursor: "pointer",
  border: "none",
  background: "transparent",
  width: "100%",
  textAlign: "left",
  fontFamily: FONT,
};

export const thStyle: CSSProperties = {
  textAlign: "left",
  padding: "12px 10px",
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: C.ink,
  borderBottom: "1px solid " + C.line,
};

export const tdStyle: CSSProperties = {
  padding: "14px 10px",
  color: C.ink,
  fontWeight: 500,
};

export function tabStyle(active: boolean): CSSProperties {
  return {
    padding: "10px 16px",
    fontSize: 14,
    fontWeight: 700,
    color: C.ink,
    background: "transparent",
    border: "none",
    borderBottom: active ? "2px solid " + C.brand : "2px solid transparent",
    marginBottom: -1,
    cursor: "pointer",
    fontFamily: FONT,
    opacity: active ? 1 : 0.7,
  };
}